import { inject, Injectable } from '@angular/core';
import { NotificationService, NotificationServiceInjector } from '@next/core-lib/notification';

import { filter, map, tap } from 'rxjs';

import { VirusMonitorEvents, VirusMonitorSyncStatusUpdatedEvent } from '../models/events';

@Injectable({
  providedIn: 'root',
})
export class VirusMonitorNotificationService {
  private readonly notificationService = inject<NotificationService>(NotificationServiceInjector);

  // Set to track completed calculations and prevent racing conditions where 'Initiated' events
  // might arrive after 'Completed' or 'Failed' events for the same task.
  private readonly completedCalculations = new Set<string>();

  private readonly entry = this.notificationService
    .on<VirusMonitorSyncStatusUpdatedEvent>(VirusMonitorEvents.virusMonitorSyncStatusUpdated)
    .pipe(map((event) => (typeof event === 'string' ? JSON.parse(event) : event) as VirusMonitorSyncStatusUpdatedEvent));

  public readonly onInitiated = this.entry.pipe(
    filter((event) =>
      event.Status === 'Initiated' && !this.completedCalculations.has(event.CalculationTaskCode),
    ),
  );

  public readonly onCompleted = this.entry.pipe(
    filter((event) => event.Status === 'Completed'),
    tap((event) => this.completedCalculations.add(event.CalculationTaskCode)),
  );

  public readonly onFailed = this.entry.pipe(
    filter((event) => event.Status === 'Failed'),
    tap((event) => this.completedCalculations.add(event.CalculationTaskCode)),
  );
}
